angular.module('app').factory('IsXmlService', function () {
    let fac = {
        isXml: isXml
    };
    function isXml(xml) {
        try {
            let xmlDoc = $.parseXML(xml);
            return true;
        }
        catch (err) {
            return false;
        }
    }
    return fac;
});
